import { Component } from '@angular/core';
import { Project } from 'src/app/models/project';
import { ServiceManager } from 'src/app/services/configurators-2d/service-manager';
import { ProjectService } from 'src/app/services/project.service';
import { MODAL, ModalService } from '../../services/modal.service';
import { HttpErrorResponse } from '@angular/common/http';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { HbmProjectDuplicationService } from 'src/app/services/hbm/hbm-project-duplication.service';

/** Résultat de la duplication d'un projet 2D : configuration clonée et configurateur d'origine. */
interface DuplicatedConfiguration {
  distributionID: string;
  projectUUID: string;
}

@Component({
  selector: 'ng-casto-project-duplicate',
  templateUrl: './project-duplicate.component.html',
})
export class ProjectDuplicateComponent {
  currentError: number;
  isLoading: boolean = false;
  onClose: (p: Project | DuplicatedConfiguration | null) => void;
  project: Project;
  projectName: string;
  private readonly onError?: () => void;

  constructor(
    public modal: ModalService,
    private readonly projectService: ProjectService,
    private readonly serviceManager: ServiceManager,
    private readonly modalService: ModalService,
    private readonly hbmProjectDuplication: HbmProjectDuplicationService
  ) {
    this.project = this.modal.currentDatas.project;
    this.projectName = this.project.projectName;
    this.onClose = this.modal.currentDatas.onClose;
    this.onError = this.modal.currentDatas.onError;
    this.currentError = 0;
  }

  checkForm() {
    this.currentError = 0;
    if (this.projectName.trim() == '') {
      this.currentError = 1;
    }

    if (this.projectName == this.project.projectName) {
      this.currentError = 2;
    }
  }

  async submit() {
    this.checkForm();
    if (this.currentError != 0) {
      return;
    }

    this.isLoading = true;
    try {
      const clonedProject = await this.duplicateProject(this.projectName.trim());
      this.isLoading = false;
      this.close(clonedProject);
    } catch (error) {
      logError(error);
      this.isLoading = false;
      this.onError?.();
      this.modalService.display(MODAL.GENERIC_ERROR, {
        errorMessage: (error as HttpErrorResponse)?.error?.message,
      });
    }
  }

  cancel() {
    this.close(null);
  }

  private async duplicateProject(title: string): Promise<Project | DuplicatedConfiguration> {
    if (this.hbmProjectDuplication.isHbmProject(this.project)) {
      return await this.hbmProjectDuplication.duplicate(this.project, title);
    }

    const service = this.serviceManager.getService(this.project.distributionID);
    if (service) {
      const configuration = await service.duplicateProjectById(this.project.projectID, title);
      return { distributionID: this.project.distributionID, projectUUID: configuration.id };
    }

    const clonedProjectUUID = await this.projectService.duplicate(this.project.projectID, this.project.projectUUID, title);
    return Object.assign(new Project(), { projectUUID: clonedProjectUUID });
  }

  private close(clonedProject: Project | DuplicatedConfiguration | null): void {
    this.modal.close(clonedProject);
    if (this.onClose) {
      this.onClose(clonedProject);
    }
  }
}
